export const FAQ_CATEGORIES = [
  { id: "bowling", nl: "Bowling", en: "Bowling" },
  { id: "food", nl: "Eten & drinken", en: "Food & drinks" },
  { id: "disco", nl: "Discobowling & evenementen", en: "Disco bowling & events" },
  { id: "payment", nl: "Betaling & reservaties", en: "Payment & reservations" },
  { id: "practical", nl: "Praktisch", en: "Practical" },
  { id: "hours", nl: "Openingsuren", en: "Opening hours" },
  { id: "contact", nl: "Contact", en: "Contact" },
  { id: "rules", nl: "Bowlingregels & prijzen", en: "Bowling rules & prizes" },
];

export const FAQ_ITEMS = [
  // Bowling
  { cat: "bowling",
    qn: "Kan ik vooraf een bowlingbaan reserveren?",
    an: "Ja, uiteraard! Het is zelfs aan te raden om vooraf te reserveren, zodat je zeker bent van een baan.",
    qe: "Can I reserve a bowling lane in advance?",
    ae: "Yes, of course! We actually recommend booking in advance, so you're sure to have a lane." },
  { cat: "bowling",
    qn: "Kan ik ook zonder reservatie komen bowlen?",
    an: "Dat is niet altijd mogelijk. Vooral op drukke momenten kunnen alle banen gereserveerd zijn. We raden aan om vooraf te reserveren of even telefonisch contact op te nemen.",
    qe: "Can I come bowling without a reservation?",
    ae: "That's not always possible. Especially at busy times, all lanes may be booked. We recommend reserving in advance or giving us a quick call." },
  { cat: "bowling",
    qn: "Hoe lang duurt één bowlingbeurt?",
    an: "Bij Bowling Helios betaal je per spel en per persoon. Reken gemiddeld op ongeveer 10 minuten per persoon per spel. Bij kinderen kan een spelletje wat langer duren.",
    qe: "How long does one game take?",
    ae: "At Bowling Helios you pay per game and per person. Count on roughly 10 minutes per person per game. With children a game can take a bit longer." },
  { cat: "bowling",
    qn: "Met hoeveel personen kunnen we op één baan?",
    an: "Per bowlingbaan kunnen maximaal 7 personen spelen.",
    qe: "How many people can play on one lane?",
    ae: "A maximum of 7 people can play per bowling lane." },
  { cat: "bowling",
    qn: "Kunnen kinderen ook bowlen?",
    an: "Zeker! Ook kinderen zijn van harte welkom. Voor jonge kinderen kan de hulp van een volwassene nodig zijn. We beschikken bovendien over verschillende hulpmiddelen om het bowlen makkelijker te maken.",
    qe: "Can children bowl too?",
    ae: "Absolutely! Children are very welcome. Young children may need an adult's help. We also have several aids to make bowling easier." },
  { cat: "bowling",
    qn: "Vanaf welke leeftijd mogen kinderen bowlen?",
    an: "Er is geen vaste minimumleeftijd. Zodra een kind zelfstandig of met wat hulp een bowlingbal kan hanteren, kan het meedoen. Voor de allerkleinsten hebben we hulpmiddelen.",
    qe: "From what age can children bowl?",
    ae: "There's no fixed minimum age. As soon as a child can handle a bowling ball, independently or with a little help, they can join in. We have aids for the very little ones too." },
  { cat: "bowling",
    qn: "Hebben jullie kinder- of lichtgewicht bowlingballen?",
    an: "Ja! We hebben bowlingballen vanaf 6 pond (ongeveer 2,8 kg).",
    qe: "Do you have children's or lightweight bowling balls?",
    ae: "Yes! We have bowling balls from 6 pounds (about 2.8 kg)." },
  { cat: "bowling",
    qn: "Zijn er bumpers voor kinderen?",
    an: "Ja! Bumpers kunnen per kind afzonderlijk worden ingesteld.",
    qe: "Are there bumpers for children?",
    ae: "Yes! Bumpers can be set individually per child." },
  { cat: "bowling",
    qn: "Kunnen we meerdere banen tegelijk reserveren?",
    an: "Ja! Voor grotere groepen is het mogelijk om meerdere banen tegelijk te reserveren. We raden aan om dit tijdig te doen.",
    qe: "Can we reserve multiple lanes at once?",
    ae: "Yes! For larger groups it's possible to reserve multiple lanes at the same time. We recommend doing this well in advance." },
  { cat: "bowling",
    qn: "Kan ik een specifieke baan aanvragen?",
    an: "Je mag altijd een voorkeur doorgeven. We proberen hier rekening mee te houden, maar dit hangt af van de beschikbaarheid op het moment van reserveren.",
    qe: "Can I request a specific lane?",
    ae: "You can always let us know your preference. We try to take it into account, but it depends on availability at the time of booking." },
  { cat: "bowling",
    qn: "Kan ik mijn reservatie annuleren?",
    an: "Ja, mits je ons tijdig op de hoogte brengt. Bij een laattijdige annulering of no-show kan er een bedrag in rekening worden gebracht.",
    qe: "Can I cancel my reservation?",
    ae: "Yes, as long as you let us know in time. For a late cancellation or no-show, a fee may be charged." },
  { cat: "bowling",
    qn: "Kan ik mijn reservatie verplaatsen?",
    an: "Ja, dat is mogelijk. Neem hiervoor zo snel mogelijk contact met ons op.",
    qe: "Can I move my reservation?",
    ae: "Yes, that's possible. Please contact us as soon as possible to arrange this." },
  { cat: "bowling",
    qn: "Wat gebeurt er als ik te laat ben?",
    an: "We proberen je reservatie zo goed mogelijk te behouden. Ben je meer dan 15 minuten te laat zonder ons te verwittigen, dan kan het zijn dat we de baan aan andere klanten moeten geven.",
    qe: "What happens if I'm late?",
    ae: "We try to keep your reservation as long as possible. However, if you're more than 15 minutes late without letting us know, we may have to give the lane to other guests." },
  { cat: "bowling",
    qn: "Moet ik bowlingschoenen dragen?",
    an: "Ja. Bowlingschoenen zijn verplicht wanneer je op de approach en tijdens het bowlen komt.",
    qe: "Do I have to wear bowling shoes?",
    ae: "Yes. Bowling shoes are mandatory on the approach and while bowling." },
  { cat: "bowling",
    qn: "Zijn bowlingschoenen inbegrepen?",
    an: "Bowlingschoenen zijn niet inbegrepen in de spelprijs. Je betaalt eenmalig €1 huur per persoon.",
    qe: "Are bowling shoes included?",
    ae: "Bowling shoes are not included in the game price. You pay a one-time €1 rental per person." },
  { cat: "bowling",
    qn: "Kan ik mijn eigen bowlingbal meenemen?",
    an: "Ja, natuurlijk! Je mag gerust je eigen bowlingbal gebruiken.",
    qe: "Can I bring my own bowling ball?",
    ae: "Yes, of course! Feel free to use your own bowling ball." },
  { cat: "bowling",
    qn: "Kan ik mijn eigen bowlingschoenen meenemen?",
    an: "Ja, dat mag. Laat dit even weten bij je reservatie, zodat we de €1 huur voor bowlingschoenen niet aanrekenen.",
    qe: "Can I bring my own bowling shoes?",
    ae: "Yes, that's allowed. Mention it when booking so we don't charge the €1 shoe rental." },
  { cat: "bowling",
    qn: "Mag ik op sokken bowlen?",
    an: "Nee. Om veiligheids- en hygiënische redenen is bowlen op sokken niet toegestaan.",
    qe: "Can I bowl in my socks?",
    ae: "No. For safety and hygiene reasons, bowling in socks is not allowed." },
  { cat: "bowling",
    qn: "Kunnen rolstoelgebruikers bij jullie bowlen?",
    an: "Ja! We beschikken over hulpmiddelen, waaronder een rolstoelhelling, om rolstoelgebruikers te helpen bij het bowlen. Spreek ons gerust vooraf aan, zodat we kunnen bekijken wat voor jou het beste werkt.",
    qe: "Can wheelchair users bowl with you?",
    ae: "Yes! We have aids, including a wheelchair ramp, to help wheelchair users bowl. Feel free to talk to us in advance so we can see what works best for you." },
  // Eten & drinken
  { cat: "food",
    qn: "Mogen we bij de bowlingbanen eten en drinken?",
    an: "Ja, eten en drinken mag gewoon aan je tafel bij de baan. Alleen op de approach — de aanloopzone van de baan — is eten en drinken niet toegestaan.",
    qe: "Can we eat and drink at the bowling lanes?",
    ae: "Yes, eating and drinking is perfectly fine at your table by the lane. Only on the approach — the run-up area of the lane — food and drinks are not allowed." },
  { cat: "food",
    qn: "Mag ik mijn eigen consumpties meenemen?",
    an: "Nee, eigen dranken meenemen is niet toegestaan — dat hoort nu eenmaal niet in een horecazaak. Wel goed om te weten: wie bij ons niets consumeert, betaalt het standaardtarief van €5,50 (dit kan per dag variëren). Neem je wel een consumptie bij ons, dan krijg je korting op dat tarief. Zo blijft het voor iedereen eerlijk én gezellig.",
    qe: "Can I bring my own drinks?",
    ae: "No, bringing your own drinks is not allowed — that's simply not done in a hospitality venue. Good to know though: guests who don't order any drinks pay the standard rate of €5.50 (this can vary per day). If you do order drinks with us, you get a discount on that rate. That way it stays fair and fun for everyone." },
  { cat: "food",
    qn: "Mag ik mijn eigen eten meenemen?",
    an: "Nee, ook eigen eten meebrengen is niet toegestaan — dat hoort niet in een horecazaak. Handig om te weten: wie bij ons eet of drinkt, krijgt korting op het standaardtarief.",
    qe: "Can I bring my own food?",
    ae: "No, bringing your own food is not allowed either — that's not done in a hospitality venue. Good to know: guests who eat or drink with us get a discount on the standard rate." },
  { cat: "food",
    qn: "Mag ik mijn eigen verjaardagstaart meebrengen?",
    an: "Dat kan in overleg. Neem vooraf even contact met ons op, zodat we dit samen kunnen bespreken.",
    qe: "Can I bring my own birthday cake?",
    ae: "That's possible in consultation. Please contact us in advance so we can discuss it together." },
  { cat: "food",
    qn: "Kunnen we vooraf eten reserveren?",
    an: "Ja! Dat kan zeker en is bij grotere groepen zelfs aan te raden. Zo kan onze keuken zich goed voorbereiden.",
    qe: "Can we reserve food in advance?",
    ae: "Yes! That's definitely possible and even recommended for larger groups, so our kitchen can prepare properly." },
  { cat: "food",
    qn: "Kunnen we met een grote groep samen eten?",
    an: "Ja! Ook grotere groepen kunnen bij ons terecht. Voor groepen raden we aan om vooraf te reserveren.",
    qe: "Can we dine with a large group?",
    ae: "Yes! Larger groups are welcome too. For groups we recommend reserving in advance." },
  { cat: "food",
    qn: "Hebben jullie cocktails?",
    an: "Ja! We hebben verschillende cocktails en voegen regelmatig nieuwe toe. De cocktails op onze menukaart zijn dus niet het enige aanbod — rondom de bowling vind je nog verschillende andere opties.",
    qe: "Do you have cocktails?",
    ae: "Yes! We have various cocktails and regularly add new ones. The cocktails on our menu are not the only options — you'll find several more around the bowling area." },
  { cat: "food",
    qn: "Hebben jullie mocktails?",
    an: "Jazeker! Ook voor wie liever geen alcohol drinkt, hebben we verschillende lekkere mocktails.",
    qe: "Do you have mocktails?",
    ae: "Absolutely! For those who prefer no alcohol, we have several delicious mocktails." },
  { cat: "food",
    qn: "Hebben jullie slush?",
    an: "Ja! We hebben onder andere Piña Colada en Blue Hawaii. Deze zijn verkrijgbaar met of zonder alcohol.",
    qe: "Do you have slush?",
    ae: "Yes! We have Piña Colada and Blue Hawaii, among others. Available with or without alcohol." },
  // Disco bowling & evenementen
  { cat: "disco",
    qn: "Organiseren jullie discobowling?",
    an: "Ja! Bij Bowling Helios kun je terecht voor gezellige discobowling met muziek en sfeerverlichting.",
    qe: "Do you organise disco bowling?",
    ae: "Yes! At Bowling Helios you can enjoy cosy disco bowling with music and atmospheric lighting." },
  { cat: "disco",
    qn: "Heeft jullie discobowling flikkerende lichten?",
    an: "Ja. De verlichting is onderdeel van de disco-ervaring en kan momenteel helaas niet aangepast worden. Wie weet komen er in de toekomst nog nieuwe lichteffecten!",
    qe: "Does your disco bowling have flashing lights?",
    ae: "Yes. The lighting is part of the disco experience and unfortunately cannot be adjusted at the moment. Who knows, new light effects may be added in the future!" },
  { cat: "disco",
    qn: "Is discobowling geschikt voor kinderen?",
    an: "Zeker! We organiseren speciale kinder-discobowling op woensdag en zaterdag. In overleg kan discobowling ook op andere momenten worden aangepast aan de leeftijd van de groep.",
    qe: "Is disco bowling suitable for children?",
    ae: "Absolutely! We organise special kids' disco bowling on Wednesdays and Saturdays. In consultation, disco bowling can also be adapted to the age of the group at other times." },
  { cat: "disco",
    qn: "Kunnen we tijdens discobowling verzoeknummers aanvragen?",
    an: "Ja! Heb je een favoriete song? Laat het ons weten!",
    qe: "Can we request songs during disco bowling?",
    ae: "Yes! Have a favourite song? Let us know!" },
  { cat: "disco",
    qn: "Kunnen jullie muziek voorzien voor een verjaardagsfeest?",
    an: "Ja! We kunnen de muziek aanpassen aan de leeftijd en het type feest.",
    qe: "Can you provide music for a birthday party?",
    ae: "Yes! We can adapt the music to the age and type of party." },
  // Betaling & reservaties
  { cat: "payment",
    qn: "Kunnen we met Bancontact betalen?",
    an: "Ja!",
    qe: "Can we pay with Bancontact?",
    ae: "Yes!" },
  { cat: "payment",
    qn: "Kunnen we contant betalen?",
    an: "Ja, contante betaling is mogelijk.",
    qe: "Can we pay in cash?",
    ae: "Yes, cash payment is possible." },
  { cat: "payment",
    qn: "Kunnen we met een bankkaart betalen?",
    an: "Ja, je kunt bij ons met de kaart betalen.",
    qe: "Can we pay by bank card?",
    ae: "Yes, you can pay by card with us." },
  { cat: "payment",
    qn: "Kunnen we vooraf online betalen?",
    an: "In de meeste gevallen betaal je ter plaatse. Voor bepaalde acties of arrangementen, zoals Social Deal, kan vooraf betalen wel van toepassing zijn.",
    qe: "Can we pay online in advance?",
    ae: "In most cases you pay on site. For certain promotions or packages, such as Social Deal, advance payment may apply." },
  { cat: "payment",
    qn: "Moet ik een voorschot betalen voor een reservatie?",
    an: "Nee, normaal gezien vragen we geen voorschot. Bij een no-show of laattijdige annulering kan er wel een bedrag worden aangerekend.",
    qe: "Do I have to pay a deposit for a reservation?",
    ae: "No, normally we don't ask for a deposit. For a no-show or late cancellation, a fee may be charged." },
  { cat: "payment",
    qn: "Kan ik mijn reservatie telefonisch maken?",
    an: "Ja! Je kunt telefonisch contact met ons opnemen om een reservatie te maken.",
    qe: "Can I make my reservation by phone?",
    ae: "Yes! You can call us to make a reservation." },
  { cat: "payment",
    qn: "Kan ik online reserveren?",
    an: "Ja! Je kunt eenvoudig online reserveren via ons reserveringsplatform op deze website.",
    qe: "Can I book online?",
    ae: "Yes! You can easily book online via the reservation platform on this website." },
  { cat: "payment",
    qn: "Kan ik dezelfde dag nog reserveren?",
    an: "Ja, zolang er nog beschikbaarheid is. We raden aan om zo vroeg mogelijk te reserveren, zeker tijdens drukke periodes.",
    qe: "Can I still book on the same day?",
    ae: "Yes, as long as there's availability. We recommend booking as early as possible, especially during busy periods." },
  { cat: "payment",
    qn: "Kan ik voor een grote groep reserveren?",
    an: "Zeker! Grote groepen zijn welkom. Neem bij voorkeur tijdig contact met ons op, zodat we alles goed kunnen voorbereiden.",
    qe: "Can I book for a large group?",
    ae: "Absolutely! Large groups are welcome. Preferably contact us in good time so we can prepare everything properly." },
  // Praktisch
  { cat: "practical",
    qn: "Is er gratis parking?",
    an: "Ja! Bij Bowling Helios kun je gratis parkeren.",
    qe: "Is there free parking?",
    ae: "Yes! Parking at Bowling Helios is free." },
  { cat: "practical",
    qn: "Is de bowling toegankelijk voor rolstoelgebruikers?",
    an: "Ja! De bowling is toegankelijk voor rolstoelgebruikers. Houd er wel rekening mee dat de ondergrond van de parking uit steentjes bestaat, waardoor deze voor sommige rolstoelen wat moeilijker kan zijn.",
    qe: "Is the bowling alley wheelchair accessible?",
    ae: "Yes! The bowling alley is wheelchair accessible. Do note that the car park surface consists of gravel, which can be a bit more difficult for some wheelchairs." },
  { cat: "practical",
    qn: "Zijn er toiletten aanwezig?",
    an: "Ja, er zijn toiletten aanwezig.",
    qe: "Are there toilets?",
    ae: "Yes, toilets are available." },
  { cat: "practical",
    qn: "Hebben jullie een toilet voor mindervaliden?",
    an: "Helaas niet. Door de beperkte beschikbare ruimte beschikken we momenteel niet over een aangepast toilet.",
    qe: "Do you have an accessible toilet?",
    ae: "Unfortunately not. Due to limited available space, we currently don't have an adapted toilet." },
  { cat: "practical",
    qn: "Mag ik mijn huisdier meenemen?",
    an: "Huisdieren zijn toegestaan, maar laat dit vooraf even weten.",
    qe: "Can I bring my pet?",
    ae: "Pets are allowed, but please let us know in advance." },
  { cat: "practical",
    qn: "Is er airconditioning?",
    an: "Ja! We zorgen ervoor dat het binnen aangenaam blijft. De temperatuur wordt rond de 21 °C gehouden.",
    qe: "Is there air conditioning?",
    ae: "Yes! We make sure it stays pleasant inside. The temperature is kept around 21 °C." },
  { cat: "practical",
    qn: "Is er wifi?",
    an: "Ja, er is wifi beschikbaar.",
    qe: "Is there wifi?",
    ae: "Yes, wifi is available." },
  { cat: "practical",
    qn: "Kunnen we met een grote groep terecht?",
    an: "Zeker! Grote groepen zijn welkom. Reserveer wel tijdig, zodat we voldoende banen en ruimte voor jullie kunnen voorzien.",
    qe: "Can we visit with a large group?",
    ae: "Absolutely! Large groups are welcome. Do book in time so we can provide enough lanes and space for you." },
  // Openingsuren
  { cat: "hours",
    qn: "Wat zijn jullie openingsuren?",
    an: "Onze actuele openingsuren vind je altijd terug op de contactpagina van onze website.",
    qe: "What are your opening hours?",
    ae: "You can always find our current opening hours on the contact page of our website." },
  { cat: "hours",
    qn: "Zijn jullie open op feestdagen?",
    an: "Ja! Ook op feestdagen zijn we geopend. Valt een feestdag op een maandag? Dan zijn we open vanaf 11:00 tot sluiting.",
    qe: "Are you open on public holidays?",
    ae: "Yes! We're open on public holidays too. If a holiday falls on a Monday, we're open from 11:00 until closing." },
  { cat: "hours",
    qn: "Zijn jullie open tijdens de schoolvakanties?",
    an: "Ja! Tijdens schoolvakanties zijn we elke dag open — ook op maandag, van 11:00 tot 23:00 (of tot sluiting als het wat uitloopt).",
    qe: "Are you open during school holidays?",
    ae: "Yes! During school holidays we're open every day — including Mondays, from 11:00 to 23:00 (or until closing if the evening runs late)." },
  { cat: "hours",
    qn: "Kunnen schoolgroepen of grote groepen buiten de openingsuren komen?",
    an: "Ja! Schoolgroepen, verenigingen en grote groepen kunnen ook buiten de normale openingsuren reserveren. Neem vooraf contact met ons op, dan bekijken we samen de mogelijkheden.",
    qe: "Can school groups or large groups come outside opening hours?",
    ae: "Yes! School groups, associations and large groups can also book outside regular opening hours. Contact us in advance and we'll look at the possibilities together." },
  // Contact
  { cat: "contact",
    qn: "Kunnen jullie reservaties telefonisch aannemen?",
    an: "Ja! Reservaties kunnen telefonisch, via e-mail of via ons online reserveringsplatform worden gemaakt.",
    qe: "Can you take reservations by phone?",
    ae: "Yes! Reservations can be made by phone, by email or via our online reservation platform." },
  { cat: "contact",
    qn: "Kunnen we via Facebook of Instagram contact opnemen?",
    an: "Ja! Je kunt ons ook via Facebook en Instagram bereiken. Onze sociale media vind je onderaan op onze website.",
    qe: "Can we contact you via Facebook or Instagram?",
    ae: "Yes! You can also reach us via Facebook and Instagram. You'll find our social media at the bottom of our website." },
  { cat: "contact",
    qn: "Hoe snel beantwoorden jullie berichten?",
    an: "We proberen berichten zo snel mogelijk te beantwoorden. Meestal krijg je binnen enkele minuten tot ongeveer een uur antwoord, afhankelijk van de drukte.",
    qe: "How quickly do you answer messages?",
    ae: "We try to answer messages as quickly as possible. Usually you'll get a reply within a few minutes to about an hour, depending on how busy we are." },
  { cat: "contact",
    qn: "Waar kan ik terecht met een klacht of probleem?",
    an: "Heb je een probleem of ben je ergens niet tevreden over? Neem dan gerust contact met ons op via telefoon, e-mail of sociale media. We luisteren graag naar je en zoeken samen naar een oplossing.",
    qe: "Where can I go with a complaint or problem?",
    ae: "Do you have a problem or are you not satisfied with something? Feel free to contact us by phone, email or social media. We're happy to listen and will look for a solution together." },
  // Bowlingregels & prijzen
  { cat: "rules",
    qn: "Zijn er bowlingregels?",
    an: "Ja! Bij Bowling Helios zijn er duidelijke bowlingregels. Deze vind je terug in de bowling zelf. We vragen iedereen om deze regels te respecteren, zodat iedereen veilig en met plezier kan bowlen.",
    qe: "Are there bowling rules?",
    ae: "Yes! Bowling Helios has clear bowling rules, which you'll find in the venue itself. We ask everyone to respect these rules so everyone can bowl safely and have fun." },
  { cat: "rules",
    qn: "Waar kan ik de bowlingregels terugvinden?",
    an: "De belangrijkste regels en afspraken hangen duidelijk zichtbaar in de bowling. Twijfel je ergens over? Vraag het gerust aan een medewerker!",
    qe: "Where can I find the bowling rules?",
    ae: "The main rules and agreements are clearly displayed in the venue. Unsure about something? Feel free to ask a staff member!" },
  { cat: "rules",
    qn: "Zijn de bowlingregels verplicht?",
    an: "Ja. De regels zijn er voor de veiligheid, het spelplezier en het comfort van al onze bezoekers. We verwachten dan ook dat iedereen zich hieraan houdt.",
    qe: "Are the bowling rules mandatory?",
    ae: "Yes. The rules exist for the safety, enjoyment and comfort of all our visitors. We therefore expect everyone to follow them." },
  { cat: "rules",
    qn: "Kunnen we prijzen winnen tijdens het bowlen?",
    an: "Zeker! Tijdens verschillende speciale bowlingavonden zijn er leuke prijzen te winnen.",
    qe: "Can we win prizes while bowling?",
    ae: "Absolutely! During various special bowling evenings there are fun prizes to win." },
  { cat: "rules",
    qn: "Kunnen we prijzen winnen tijdens Jenever Discobowling?",
    an: "Ja! Tijdens onze Jenever Discobowling zijn er verschillende prijzen en extra's te winnen. De exacte acties en spelregels kunnen per editie verschillen. Houd onze sociale media en website in de gaten voor de actuele informatie.",
    qe: "Can we win prizes during Jenever Disco Bowling?",
    ae: "Yes! During our Jenever Disco Bowling there are various prizes and extras to win. The exact promotions and game rules can differ per edition. Keep an eye on our social media and website for the latest information." },
  { cat: "rules",
    qn: "Zijn er ook prijzen tijdens thema-bowling?",
    an: "Ja! Bij onze verschillende thema-bowlingavonden voorzien we regelmatig leuke prijzen, acties en verrassingen. Elk thema kan zijn eigen spelregels en prijzen hebben.",
    qe: "Are there prizes during theme bowling too?",
    ae: "Yes! At our various theme bowling evenings we regularly offer fun prizes, promotions and surprises. Each theme can have its own game rules and prizes." },
  { cat: "rules",
    qn: "Waar kan ik de actuele acties en prijzen vinden?",
    an: "De actuele acties, thema-avonden en bijhorende prijzen worden aangekondigd via onze website en sociale media. In de bowling zelf vind je ook de nodige informatie over de acties van die avond.",
    qe: "Where can I find the current promotions and prizes?",
    ae: "Current promotions, theme nights and accompanying prizes are announced via our website and social media. In the venue itself you'll also find information about that evening's promotions." },
];
